"use strict";
/**************************************************************************************************
 *
 *       @file ./response-callback.ts
 *
 *       Callback object for handling sync response
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var mad_utils_1 = require("mad-utils");
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('response-callback.ts', shared_1.Styles.hatBlock);
/********************************************* EXPORT *********************************************/
/* Export wrapped ResponseCallback */
exports.ResponseCallback = javelin_exports_1.javelin.sync.model.ResponseCallback;
mad_utils_1.defineProp(exports.ResponseCallback.prototype, 'JVLN_CLASS_NAME', 'ResponseCallback', false);
//# sourceMappingURL=response-callback.js.map